export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: "连载中" | "已完结";
  tags: string[];
  updateDate: string;
  content?: string;
}

export const comics: Comic[] = [
  {
    id: "comic-01",
    title: "暗夜蔷薇",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=Dark%20romantic%20manga%20style%20book%20cover%20featuring%20elegant%20woman%20with%20rose%20flowers%20gothic%20atmosphere%20deep%20red%20and%20black%20tones%20clean%20minimalist%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    category: "romance",
    description: "一桩离奇的谋杀案，一朵暗夜中绽放的蔷薇。当真相一层层被揭开，爱与恨的边界变得模糊。她是受害者，还是加害者？在这场致命的游戏中，没有人能全身而退。",
    rating: 4.8,
    views: 1256000,
    chapters: 86,
    status: "连载中",
    tags: ["悬疑恋爱", "都市", "复仇"],
    updateDate: "2026-08-04",
    content: "在首尔繁华的江南区，一栋高级公寓里发生了一起离奇死亡事件。表面看是意外，但刑警李俊浩总觉得事有蹊跷。死者是知名财阀千金，而她的闺蜜——美术讲师沈若薇，成了最大的嫌疑人。随着调查深入，一段被尘封的往事逐渐浮出水面...",
  },
  {
    id: "comic-02",
    title: "剑与魔法之诗",
    author: "朴俊赫",
    cover: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20book%20cover%20featuring%20warrior%20with%20sword%20magical%20glowing%20elements%20dramatic%20lighting%20medieval%20fantasy%20atmosphere%20warm%20golden%20tones%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    category: "fantasy",
    description: "平凡少年意外穿越到剑与魔法的世界，从最弱小的冒险者开始，一步步成长为传说中的英雄。热血与感动交织的史诗冒险，永不言弃的少年成长记。",
    rating: 4.9,
    views: 2890000,
    chapters: 152,
    status: "连载中",
    tags: ["异世界", "冒险", "成长"],
    updateDate: "2026-08-04",
    content: "高中生姜太宇在一次意外中穿越到了一个充满魔法与怪物的异世界。在这里，他被认定为无能力者，连最基础的火球术都施展不出。但太宇发现了一个秘密——他拥有一个独特的能力：将所有受到的伤害转化为经验值...",
  },
  {
    id: "comic-03",
    title: "盛夏方程式",
    author: "李恩静",
    cover: "https://readdy.ai/api/search-image?query=Youth%20romance%20manga%20book%20cover%20featuring%20two%20teenagers%20under%20cherry%20blossoms%20summer%20school%20setting%20warm%20pastel%20pink%20tones%20clean%20minimalist%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    category: "school",
    description: "高三最后一个夏天，学霸班长与转校生之间的青涩恋爱故事。那些藏在习题册里的纸条，放学后天台上的约定，都成了最美的盛夏记忆。",
    rating: 4.7,
    views: 980000,
    chapters: 64,
    status: "已完结",
    tags: ["校园恋爱", "青春", "治愈"],
    updateDate: "2026-08-03",
    content: "高三开学第一天，班级里来了一个从首尔转来的转校生——韩雅琳。她坐在了年级第一学霸金在宇的旁边。雅琳性格开朗活泼，而金在宇则沉默寡言。两个性格截然不同的人，在这个决定命运的夏天，开始了他们最美好的故事...",
  },
  {
    id: "comic-04",
    title: "血族伯爵",
    author: "崔振宇",
    cover: "https://readdy.ai/api/search-image?query=Dark%20vampire%20manga%20book%20cover%20featuring%20elegant%20vampire%20nobleman%20gothic%20castle%20background%20deep%20crimson%20and%20black%20tones%20mysterious%20atmosphere%20clean%20product%20photography%20on%20soft%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    category: "fantasy",
    description: "沉睡千年的血族伯爵在现代都市苏醒，却发现血族早已没落。为了重振血族荣光，他必须在这个陌生的时代中找到新的生存之道。华丽画风，暗黑优雅。",
    rating: 4.8,
    views: 1560000,
    chapters: 98,
    status: "连载中",
    tags: ["吸血鬼", "都市", "暗黑"],
    updateDate: "2026-08-04",
    content: "公元1024年，血族伯爵弗拉迪米尔在与猎魔人的决战中陷入沉睡。一千年后，他在现代首尔的地下停车场中苏醒。曾经掌控半个欧洲的血族帝国已经烟消云散，他成了世界上最后一个纯血血族...",
  },
  {
    id: "comic-05",
    title: "爆笑校园日记",
    author: "赵美兰",
    cover: "https://readdy.ai/api/search-image?query=Funny%20comedy%20manga%20book%20cover%20featuring%20cartoon%20students%20in%20school%20uniform%20bright%20colorful%20yellow%20and%20orange%20tones%20playful%20vibrant%20atmosphere%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    category: "comedy",
    description: "废柴高中生和他的一群奇葩同学们的爆笑日常。每一话都能让你笑到肚子疼！轻松减压的校园喜剧，不开心的时候就看它！",
    rating: 4.6,
    views: 2100000,
    chapters: 200,
    status: "连载中",
    tags: ["搞笑", "校园", "日常"],
    updateDate: "2026-08-05",
    content: "我叫金多运，是南山高中最普通的学生——好吧，可能不太普通，因为我拥有一项特殊技能：无论走到哪里都能把平静的校园生活变成一场闹剧。我的好友们分别是：整天研究奇怪发明的科学狂人、中二病晚期患者、以及一个看起来很正常但实际最不正常的优等生...",
  },
  {
    id: "comic-06",
    title: "第七层地狱",
    author: "姜贤宇",
    cover: "https://readdy.ai/api/search-image?query=Horror%20thriller%20manga%20book%20cover%20featuring%20ominous%20apartment%20building%20dark%20mysterious%20atmosphere%20greenish%20dark%20tones%20creepy%20vibe%20clean%20product%20photography%20on%20soft%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    category: "horror",
    description: "一栋老旧公寓的七楼住户接连失踪，没有人知道原因。直到新搬来的住户发现了隐藏在墙壁里的秘密。每翻一页都让你毛骨悚然的悬疑恐怖力作。",
    rating: 4.9,
    views: 1890000,
    chapters: 72,
    status: "连载中",
    tags: ["悬疑恐怖", "都市怪谈", "解谜"],
    updateDate: "2026-08-03",
    content: "为了省房租，大学生林秀敏搬进了月租只要10万韩元的首尔老旧公寓。但搬进来的第一天，她就发现了一个奇怪的现象：这栋楼的七楼，似乎从来没有人进出过。邻居们对七楼讳莫如深，房东也避而不谈...",
  },
  {
    id: "comic-07",
    title: "星海沉浮",
    author: "郑允熙",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20drama%20manga%20book%20cover%20featuring%20elegant%20woman%20in%20evening%20gown%20luxury%20interior%20dramatic%20warm%20amber%20lighting%20sophisticated%20atmosphere%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    category: "drama",
    description: "娱乐圈顶流女星与幕后制作人的禁忌之恋，在镁光灯下隐藏的秘密，在星光背后流淌的真心。一部描绘韩国娱乐圈真实面纱的深度剧情漫画。",
    rating: 4.7,
    views: 1340000,
    chapters: 110,
    status: "连载中",
    tags: ["娱乐圈", "恋爱", "现实向"],
    updateDate: "2026-08-04",
    content: "韩国顶级女演员韩素希在事业的巅峰期，遇到了改变她一生的人——新人制作人李泰民。在光鲜亮丽的娱乐圈背后，隐藏着不为人知的黑暗面。两个人在名利场中互相取暖，却不知道更大的风暴正在酝酿...",
  },
  {
    id: "comic-08",
    title: "格斗之王",
    author: "金泰勋",
    cover: "https://readdy.ai/api/search-image?query=Action%20fighting%20manga%20book%20cover%20featuring%20martial%20artist%20in%20dynamic%20pose%20fiery%20orange%20and%20red%20energy%20effects%20intense%20combat%20atmosphere%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    category: "action",
    description: "从小被父亲严格训练的天才格斗少年，在地下格斗场上书写属于他的传奇。拳拳到肉的战斗场面，热血沸腾的格斗之旅，真正的强者之路！",
    rating: 4.8,
    views: 2450000,
    chapters: 135,
    status: "连载中",
    tags: ["格斗", "热血", "竞技"],
    updateDate: "2026-08-05",
    content: "全国高中格斗大赛冠军——18岁的崔道贤，收到了来自地下格斗组织的邀请。在这里，没有规则，没有护具，只有最纯粹的格斗。道贤的父亲曾是地下格斗的传奇，但因为一场阴谋而永远退出了舞台。如今，道贤将踏上父亲曾经走过的路...",
  },
  {
    id: "comic-09",
    title: "月光花庭",
    author: "韩素英",
    cover: "https://readdy.ai/api/search-image?query=Historical%20romance%20manga%20book%20cover%20featuring%20traditional%20Korean%20hanbok%20elegant%20woman%20ancient%20palace%20garden%20soft%20moonlight%20ethereal%20green%20and%20cream%20tones%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    category: "historical",
    description: "朝鲜王朝时期，一位平民女子被选入宫中成为宫女，在宫廷权谋中挣扎求存。唯美古风画风，细腻描绘古代韩国宫廷生活的动人故事。",
    rating: 4.9,
    views: 1670000,
    chapters: 92,
    status: "连载中",
    tags: ["古风", "宫廷", "权谋"],
    updateDate: "2026-08-04",
    content: "正祖年间，平民女子李青荷被选入宫中成为一名普通的宫女。她聪慧过人，精通医术，很快就得到了中殿娘娘的赏识。但在深宫之中，才华往往是一把双刃剑。当她无意中发现了宫廷中隐藏的巨大秘密后，她的命运从此改变...",
  },
  {
    id: "comic-10",
    title: "幸福料理",
    author: "孙美妍",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cooking%20food%20manga%20book%20cover%20featuring%20cheerful%20chef%20with%20delicious%20Korean%20dishes%20cozy%20kitchen%20warm%20orange%20and%20cream%20tones%20comforting%20vibe%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    category: "drama",
    description: "失业的上班族偶然继承了奶奶的小餐馆，在烹饪中重新找回了生活的意义。每道菜背后都有一个动人的故事，温暖治愈的美食漫画，适合在深夜慢慢品读。",
    rating: 4.6,
    views: 890000,
    chapters: 48,
    status: "已完结",
    tags: ["美食", "治愈", "人生"],
    updateDate: "2026-08-02",
    content: "31岁的职场人柳志勋被公司裁员后，整个人陷入了低谷。就在他最迷茫的时候，他收到了奶奶去世的消息——以及她留给他的那家位于首尔老城区的小餐馆。起初志勋只想把餐馆卖掉，但当他第一次亲手做出奶奶的招牌菜时，一切都变了...",
  },
  {
    id: "comic-11",
    title: "禁断之恋",
    author: "崔允熙",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20BL%20romance%20manga%20book%20cover%20featuring%20two%20handsome%20men%20in%20suits%20soft%20intimate%20atmosphere%20lavender%20and%20silver%20tones%20refined%20aesthetic%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    category: "bl",
    description: "财阀继承人与他的保镖之间，跨越身份与世俗的深情故事。在危险与阴谋的交织中，两颗孤独的心逐渐靠近。精致唯美的画风，细腻动人的情感描绘。",
    rating: 4.8,
    views: 1750000,
    chapters: 78,
    status: "连载中",
    tags: ["耽美", "都市", "禁断"],
    updateDate: "2026-08-05",
    content: "韩氏集团的独子韩瑞俊，从小生活在父亲的严格管控之下。当他的生命受到威胁时，父亲为他雇佣了一位顶级保镖——前特种部队成员姜河镇。起初两人彼此戒备，但在一次又一次的危险中，一种超越雇佣关系的情感悄然滋长...",
  },
  {
    id: "comic-12",
    title: "异能觉醒者",
    author: "刘智勋",
    cover: "https://readdy.ai/api/search-image?query=Superpower%20action%20manga%20book%20cover%20featuring%20young%20man%20with%20glowing%20energy%20hands%20urban%20cityscape%20dramatic%20lighting%20electric%20blue%20and%20white%20tones%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    category: "action",
    description: "某天醒来，世界上0.1%的人类突然觉醒了超能力。少年在混乱中发现了自己隐藏的力量，踏上了一条拯救与毁灭并存的道路。",
    rating: 4.7,
    views: 3200000,
    chapters: 168,
    status: "连载中",
    tags: ["超能力", "热血", "科幻"],
    updateDate: "2026-08-05",
    content: "2026年3月15日，这一天被后世称为觉醒日。全球约800万人突然获得了各种超能力。社会秩序瞬间崩溃，有人用能力作恶，有人用能力保护他人。普通高中生朴贤宇在混乱中为了保护妹妹，觉醒了独一无二的能力——时间回溯...",
  },
  {
    id: "comic-13",
    title: "甜蜜的谎言",
    author: "安素珍",
    cover: "https://readdy.ai/api/search-image?query=Sweet%20romance%20manga%20book%20cover%20featuring%20couple%20in%20cafe%20cozy%20warm%20atmosphere%20pink%20and%20cream%20pastel%20tones%20soft%20romantic%20vibe%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    category: "romance",
    description: "为了应付催婚，她找了一个假男友。没想到这个假男友居然是公司新来的CEO！一场从谎言开始的浪漫爱情喜剧就此上演。",
    rating: 4.5,
    views: 760000,
    chapters: 56,
    status: "已完结",
    tags: ["恋爱喜剧", "职场", "假戏真做"],
    updateDate: "2026-08-01",
    content: "29岁的白领李多恩，被妈妈的催婚电话逼得快疯了。在一次同学聚会上，她喝醉酒后随手抓了一个帅哥拍了张合照，发给了妈妈说这是我男朋友。第二天酒醒后，她走进公司，发现新上任的CEO就是照片里的那个人...",
  },
  {
    id: "comic-14",
    title: "午夜图书馆",
    author: "文智雅",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20fantasy%20manga%20book%20cover%20featuring%20magical%20library%20with%20floating%20books%20warm%20golden%20light%20mystical%20atmosphere%20amber%20and%20brown%20tones%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    category: "fantasy",
    description: "只有在午夜才会出现的奇幻图书馆，每本书都连接着一个平行世界。图书管理员少女穿梭于各个世界之间，寻找失落的故事。",
    rating: 4.8,
    views: 1120000,
    chapters: 66,
    status: "连载中",
    tags: ["奇幻", "平行世界", "治愈"],
    updateDate: "2026-08-03",
    content: "大学图书馆的兼职管理员沈多海，在一个加班的午夜发现图书馆的地下室出现了一道发光的门。推开门后，她进入了一座存在于时间缝隙中的奇幻图书馆。这里的每一本书都连接着一个平行世界，而她被选中成为了这座图书馆的守护者...",
  },
  {
    id: "comic-15",
    title: "反转人生",
    author: "白浩镇",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20thriller%20manga%20book%20cover%20featuring%20man%20looking%20at%20mirror%20with%20different%20reflection%20psychological%20tension%20dark%20teal%20and%20gray%20tones%20clean%20product%20photography%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    category: "horror",
    description: "一觉醒来，他发现自己与一个连环杀手交换了身体。在追查真相的过程中，越来越多的惊人秘密被揭开。反转再反转的烧脑悬疑漫画。",
    rating: 4.9,
    views: 1980000,
    chapters: 84,
    status: "连载中",
    tags: ["悬疑", "身体互换", "犯罪"],
    updateDate: "2026-08-04",
    content: "普通上班族韩东秀在一个平凡的早晨醒来，却发现自己躺在一个完全陌生的房间里。更恐怖的是，当他照镜子时，镜子里映出的是首尔连环杀人案嫌疑犯的脸。而真正的杀手，此刻正用韩东秀的身体在他的生活中行动...",
  },
];